import builder from '../builder';
import Like2Alternate from '../../streamline-icons/bold/like-2-alternate.svg';

export default builder('IconLike2AlternateBold', Like2Alternate);
